export default "__VITE_ASSET__Bchq$b5Q__"